import { GuestGroup, guestGroups } from "../shared/guest-groups";
import { wedding } from "./content";
import { escapeHtml } from "./shared/dom";

export interface GuestCard {
  name: string;
  guests: number;
  group: GuestGroup;
  reference: string;
}

export function renderGuestCard(card: GuestCard): string {
  const group = guestGroups[card.group];
  return `<article class="guest-card" style="--group-colour:${group.colour}" aria-label="Your guest card">
    <p class="guest-card-kicker">RSVP confirmed · 5 December 2026</p>
    <p class="guest-card-couple">Naanep <i>&amp;</i> Emmanuel</p>
    <div class="guest-card-band">${group.label} · ${group.colourName}</div>
    <h3>${escapeHtml(card.name)}</h3><p>${card.guests} ${card.guests === 1 ? "guest" : "guests"} · ${escapeHtml(wedding.receptionVenue)}</p>
    <p class="guest-card-reference">Reference ${escapeHtml(card.reference.slice(0, 8))}</p>
    <p class="guest-card-note">Please show your card to an usher.<br />Seating confirmed against the guest list.</p>
  </article>`;
}

// A self-contained PNG stays available offline in the guest's photo/download library.
export function downloadGuestCard(card: GuestCard): void {
  const canvas = document.createElement("canvas");
  canvas.width = 1000; canvas.height = 1300;
  const ctx = canvas.getContext("2d");
  if (!ctx) throw new Error("Image export unavailable");
  const group = guestGroups[card.group];
  ctx.fillStyle = "#161817"; ctx.fillRect(0, 0, 1000, 1300);
  ctx.strokeStyle = group.colour; ctx.lineWidth = 2; ctx.strokeRect(35, 35, 930, 1230);
  ctx.textAlign = "center";
  const text = (value: string, y: number, font: string, colour = "#fff9f6") => {
    ctx.font = font; ctx.fillStyle = colour; ctx.fillText(value, 500, y, 850);
  };
  text("RSVP CONFIRMED", 145, "22px sans-serif", group.colour);
  text("Naanep & Emmanuel", 260, "italic 64px Georgia");
  text("5 DECEMBER 2026 · ABUJA", 325, "24px sans-serif");
  ctx.fillStyle = group.colour; ctx.fillRect(36, 400, 928, 110);
  text(`${group.label.toUpperCase()} · ${group.colourName}`, 470, "bold 32px sans-serif", "#161817");
  text(card.name, 650, "52px Georgia");
  text(`${card.guests} ${card.guests === 1 ? "guest" : "guests"}`, 725, "28px sans-serif");
  text(wedding.receptionVenue, 810, "32px Georgia");
  text(wedding.receptionAddress, 865, "24px sans-serif");
  text(`REFERENCE ${card.reference.slice(0, 8)}`, 980, "24px monospace", group.colour);
  text("Please show your card to an usher.", 1090, "24px sans-serif");
  text("Seating confirmed against the guest list.", 1135, "22px sans-serif");
  const link = document.createElement("a");
  link.download = `naanep-emmanuel-guest-card-${card.reference.slice(0, 8)}.png`;
  const data = canvas.toDataURL("image/png").split(",")[1]!;
  const bytes = Uint8Array.from(atob(data), (character) => character.charCodeAt(0));
  const url = URL.createObjectURL(new Blob([bytes], { type: "image/png" }));
  link.href = url; document.body.append(link); link.click(); link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
